import { debounce } from "../utils/performance";

const qs = document.querySelector.bind(document);

const init = () => (
  attachListeners()
);

const attachListeners = () => {
  const setVariablesDebounce = debounce(setVariables, 500);

  window.addEventListener('load', setVariables);
  window.addEventListener('resize', setVariablesDebounce);
  window.addEventListener('update-css-vars', setVariablesDebounce);
};

const setVariables = () => {
  setVariable(
    'header-height',
    qs('.section-header')?.offsetHeight || 0,
    'px',
  );
  setVariable(
    'footer-height',
    qs('footer.footer')?.offsetHeight || 0,
    'px',
  );

  setVariable(
    'announcement-banner-height',
    qs('[id^="shopify-section-sections--"][id$="__announcement-bar"]')?.offsetHeight || 0,
    'px',
  );

  setVariable(
    'ge-free-shipping-container',
    qs('.ge-free-shipping-container')?.offsetHeight || 0, 
    'px'
  )

  setVariable('window-width', window.innerWidth, 'px');

  setVariable('window-height', window.innerHeight, 'px');

  setVariable('header-height', qs('.header-wrapper')?.clientHeight, 'px');
  
  setVariable('plp-subnav-height', qs('.plp-subnav')?.offsetHeight || 0, 'px')

  setVariable('filters-bar-height', qs('.filters__bar')?.offsetHeight || 0, 'px')
};

const setVariable = (name, value, unit) => {
  window.cssVariables = {
    ...(window.cssVariables || {}),
    [name]: value,
  };
  value = unit ? value + unit : value;
  document.documentElement.style.setProperty(`--${name}`, value);
};

export default init;
